<div class="modal-header">
  <h5 class="modal-title">Cancel Subscription</h5>
</div>
<div class="modal-body">
  <p class="card-text mb-3">You may close your account at any time, however, if you later wish to reactivate it after 30 days, then a <b>Data Retrieval Fee of $250 may apply</b>. If you would like to place your account on hold, then you may want to switch to the <b>Off Season</b> subscription plan. You will not be able to log in during this time, however, your data will remain available and ready to use when you switch back to a regular subscription.</p>
  <form [formGroup]="calcelSubscriptionForm">
    <div class="form-group">
      <label for="FEEDBACK">Feedback</label>
      <textarea id="FEEDBACK" type="text" class="form-control" placeholder="I am canceling my subscription because…" [rows]="5" cols="50" formControlName="changeRemarks"> </textarea>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="cancelSubscription()">Confirm</button>
  <button type="button" class="btn btn-secondary" (click)="closeModal();">Cancel</button>
</div>